var $wkForm = $(".js-wk_form");

$(function(){
    isSubmitErechnung = false;

    if($wkForm.find(".js-submit").val() == 1){
        formMsgBlockShowHide($wkForm.find(".js-form_successblock"), 5000);
    }

    $wkForm.find(".js-from_submit").on("click", function(event){
        event.preventDefault();

        if(isSubmitErechnung && typeof isSubmitErechnung != "undefined") return false;
        $currentButton = $(this);
        $currentButton.addClass("button_disabled")
        isSubmitErechnung = true;

        validSubmit = true;
        if(validSubmit){
            showLoader();

            requestData = "";
            if(typeof $wkForm[0] != "undefined"){
                $wkForm.each(function(index){
                    requestData += "&" + $(this).serialize();
                });
            }

            $.ajax({
                url:$(this).data("ajax"),
                data:requestData,
                type:"POST",
                dataType:"json",
            }).done(function(response){
                $currentButton.removeClass("button_disabled")
                isSubmitErechnung = false;

                valid = true;
                $.each(response.errors, function(idPos, errors){
                    var errorText = "";
                    $.each(errors, function(key, error){
                        if(error != ""){
                            if(errorText != "") errorText += "<br>";
                            errorText += error
                            valid = false;
                        }
                    });

                    $(".js-produkt_liste_error-" + idPos).html(errorText)
                });

                $.each(response.warnings, function(idPos, warnings){
                    var warningText = "";
                    $.each(warnings, function(key, warning){
                        if(warningText != "") warningText += "<br>";
                        warningText += warning
                    });

                    $(".js-produkt_liste_warning-" + idPos).html(warningText)
                });

                if(valid){
                    $wkForm.trigger('submit');
                }else{
                    formMsgBlockShow($wkForm.find(".js-form_errorblock"));
                }
                hideLoader();
            });
        }else{
            $currentButton.removeClass("button_disabled")
            isSubmitErechnung = false;
            formMsgBlockShow($wkForm.find(".js-form_errorblock"));
            hideLoader();
        }
    });
});